import axiosClient from "../../common/axios/axiosConfig";
import useQuery from "../../utils/useQuery";

interface RoomParticipant {
  sid: string;
  identity: string;
  name: string;
  role: "patient" | "professional";
  status: "connected" | "disconnected";
  duration: number;
  connectedAt: string;
  disconnectedAt?: string;
}

export const getParticipants = async (): Promise<RoomParticipant[]> => {
  try {
    const urlSearchParams = useQuery();
    const telemedicineToken = urlSearchParams.get("token") || "";

    const response = await axiosClient.get("/room/participants", {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`,
      },
    });

    return response.data.participants;
  } catch (err) {
    console.error("Erro ao buscar participantes:", err);
    return [];
  }
};
